import { render, staticRenderFns } from "./SetDefaultProblem.vue?vue&type=template&id=5c334544&"
import script from "./SetDefaultProblem.vue?vue&type=script&lang=js&"
export * from "./SetDefaultProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports